import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  name?: string;
  plan: string;
  credits: number;
}

interface ApiKeyInfo {
  id: string;
  name: string;
  prefix: string;
  usage_count: number;
}

interface AuthState {
  user: User | null;
  apiKey: string | null;
  apiKeys: ApiKeyInfo[];
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  setApiKey: (key: string | null) => void;
  setApiKeys: (keys: ApiKeyInfo[]) => void;
  login: (user: User, apiKey: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      apiKey: null,
      apiKeys: [],
      isAuthenticated: false,
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      setApiKey: (apiKey) => set({ apiKey }),
      setApiKeys: (apiKeys) => set({ apiKeys }),
      login: (user, apiKey) => set({ user, apiKey, isAuthenticated: true }),
      logout: () => set({ user: null, apiKey: null, apiKeys: [], isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        apiKey: state.apiKey,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
